import React, { useEffect } from "react";
import "./style.scss";
import SingleNews from "./single-news";
import useNews from "./hooks/useNews";
import { useTranslation } from "react-i18next";
import useFacility from "../../../utils/hooks/useFacility";
import EAPageHeader from "../shared/EAPageHeader";

const NewsPage: React.FC = () => {
  const { acceptTransaction, news } = useNews();
  const { t } = useTranslation();
  const facilityIds = useFacility();

  useEffect(() => {
    setTimeout(() => {
      acceptTransaction();
    }, 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  return (
    <div>
      <EAPageHeader title={t("aktualnosci")} />

      {news.length > 0 ? (
        <div className="news-wrapper flex-start flex-wrap">
          {news.map((item, index) => (
            <SingleNews item={item} key={index} />
          ))}
        </div>
      ) : (
        <div className="alert alert-yellow">
          <b>{t("brak_aktywnych_aktualnosci")}</b>
        </div>
      )}
    </div>
  );
};

export default NewsPage;
